{
  "currentTenant": "Valgt tenant"
}
